import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/energy.jpg";
import Card1 from "../Images/CIRCODU-BANNERS.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function SustainableEnergy() {
  return (
    <div className="ne-page">
      <SEO
        title="Energy"
        description="Access to sustainable energy is a cornerstone of economic growth, environmental health, and poverty reduction. CIRCODU promotes sustainable energy resource use in Uganda through clean energy solutions, rigorous testing, and capacity building."
        keywords="sustainable energy, clean energy solutions, energy efficiency, renewable energy, solar power, wind power, biomass energy, hydropower, CIRCODU, Sustainable Development Goal 7, energy access Uganda, clean energy Uganda, renewable energy Uganda, energy efficiency Uganda, solar power Uganda, wind power Uganda, biomass energy Uganda, hydropower Uganda"
        url="/our-thematic-areas/energy"
        image={Card1}
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Energy</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Our Thematic Areas
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Energy</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Energy</b>
              </h5>
              <p className="texty">
                Access to sustainable energy is not a luxury; it is a
                cornerstone of economic growth, environmental health, and
                poverty reduction. CIRCODU recognizes this reality and has made
                the promotion of sustainable energy resource use a central
                pillar of its mission, working hand-in-hand with stakeholders
                across Uganda to make clean energy a lived reality for
                households, institutions, and enterprises nationwide.
              </p>

              {/* Our Energy Vision */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🌍 Our Energy Vision</b>
              </h5>
              <p className="texty">
                We are committed to driving the transition away from harmful
                traditional energy sources toward renewable alternatives,
                including <b>solar, wind, biomass, and hydropower,</b> while
                championing energy efficiency and advocating for policies that
                embed sustainable practices at every level of society.
              </p>
              <p className="texty">
                Through this work, CIRCODU contributes directly to the
                achievement of <b>Sustainable Development Goal 7,</b> ensuring
                access to affordable, reliable, sustainable, and modern energy
                for all.
              </p>

              {/* Our Overall Objective */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🎯 Our Overall Objective</b>
              </h5>
              <p className="texty">
                To empower Ugandans across households, institutions, and
                commercial enterprises to embrace and significantly increase the
                uptake of{" "}
                <b>clean, environmentally friendly energy solutions</b> for
                cooking, lighting, and productive purposes throughout the
                country.
              </p>
              {/* Specific Objectives */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🔑 Specific Objectives</b>
              </h5>
              <ol className="texty mt-1">
                <li>
                  <b>Pioneering Clean Energy Solutions:</b> We design and
                  develop innovative, efficient energy technologies that
                  directly address Uganda's evolving energy demands, solutions
                  that are practical, scalable, and built for real communities.
                </li>
                <li className="mt-1">
                  <b>Rigorous Testing for Reliable Results:</b> Through
                  comprehensive laboratory and field-testing services, we
                  validate the performance and effectiveness of clean energy
                  technologies, ensuring that what reaches communities actually
                  works, and works well.
                </li>
                <li className="mt-1">
                  <b>Capacity Building for Clean Energy Champions:</b> We equip
                  stakeholders at every level with the knowledge and skills
                  needed to develop, implement, and maintain affordable clean
                  energy technologies, turning individuals into champions of a
                  cleaner Uganda.
                </li>
              </ol>
            </div>
            <div className="col-md-8">
              {/* Our Actions on the Ground */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>⚙️ Our Actions on the Ground</b>
              </h5>
              <ol className="texty mt-1">
                <li>
                  <b>Expanding Testing Capabilities:</b> Our testing services
                  continue to evolve to meet the growing demands of the clean
                  energy sector, encompassing:
                </li>
                <ul className="mt-2">
                  <li>
                    <b>Emissions Analysis</b> — Measuring total emissions and
                    black carbon levels of clean energy technologies
                  </li>
                  <li>
                    <b>Fuel Evaluation</b> — Assessing the performance and
                    suitability of biofuels, including briquettes and ethanol
                  </li>
                  <li>
                    <b>Electric Appliance Efficiency Testing</b> — Evaluating
                    the efficiency and safety of electric cooking appliances
                  </li>
                </ul>
                <li className="mt-1">
                  <b>Waste Heat Recovery Innovation:</b> CIRCODU designed and
                  implemented a{" "}
                  <b>briquette dryer powered by recovered waste heat energy,</b>{" "}
                  a smart, sustainable innovation that improves production
                  efficiency while minimizing environmental impact.
                </li>
                <li className="mt-1">
                  <b>Empowering Briquette Production:</b> We develop and deliver
                  targeted training programs that equip communities with the
                  hands-on skills for effective briquette production, fostering
                  local entrepreneurship, reducing dependence on harmful fuels,
                  and putting clean energy solutions directly in the hands of
                  the people.
                </li>
              </ol>
            </div>
            <div
              className="col-md-4 mb-1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="imagecard" style={{ width: "100%" }}>
                <img
                  src={Card1}
                  alt="CIRCODU Sustainable Energy Programs"
                  width="100%"
                  style={{ borderRadius: "5%", objectFit: "cover" }}
                />
              </div>
            </div>

            <hr />

            <div className="col-md-12">
              {/* Closing statement */}
              <p className="texty">
                <i>
                  Energy is the engine of progress. At CIRCODU, we are making
                  sure that the engine runs clean.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SustainableEnergy;
